<template>
  <div class="history-events">
    <div class="history-menu">
      <div class="history-menu_datepicker">
        <span v-on:click="openPicker" class="history-menu_datepicker-toogle"></span>
        <datepicker
            :language="datepicker.lang.ru"
            ref="datepicker"
            :monday-first="true"
            :input-class="datepicker.inputClass"
            :disabledDates="datepicker.disabledDates"
            v-model="datepicker.value">
        </datepicker>
      </div>
      <div class="history-menu_select-cnt">
        <div class="history-menu_select" v-on:click="changeMenuItem( 0 )"
             v-bind:class="{ 'history-menu_select__active' : activeMenuItem === 0}">
          <span class="history-menu_select-btn">Лентой</span>
        </div>
        <div class="history-menu_select" v-on:click="changeMenuItem( 1 )"
             v-bind:class="{ 'history-menu_select__active' : activeMenuItem === 1}">
          <span class="history-menu_select-btn" >По событиям</span>
        </div>
      </div>
      <div class="history-menu_filter">
        <span class="history-menu_filter-toggle" v-on:click="openFilterPanel()"></span>
      </div>
    </div>
    <div class="history_current-date history_current-date__history"
         v-if="routes.listRoutes.length && activeMenuItem === 0"
         v-on:click="selectHistoryDay()">
      <div class="history-date_val">
        {{routes.currentDate}}
      </div>
    </div>
    <div class="history_current-date" v-if="events.listEvents.length && activeMenuItem === 1">
      <div class="history-date_val">
        {{events.currentDate}}
      </div>
    </div>
    <div class="ps-lock" v-bind:class="{ 'ps-lock__active' : paginatorLock }">
    </div>
    <div class="ps-lock" v-bind:class="{ 'ps-lock__active' : activeMenuItem === -1 }">
    </div>

    <perfect-scrollbar
        v-on:wheel="routeScroll"
        @ps-y-reach-end="routeReachEnd"
        v-if="routes.listRoutes.length && activeMenuItem === 0"
        ref="routeScroll">
      <div class="history-list">
        <div class="history-item"
             v-for="(dateRoute, indexDateRoute) in routes.listRoutes"
             v-bind:key="indexDateRoute">
          <div class="history-date history-date__history"
               v-on:click="selectHistoryDay( dateRoute )">
            <div class="history-date_val">
              {{dateRoute.day}}
              {{listMonth[dateRoute.month]}}
            </div>
          </div>
          <div class="history-details"
               v-bind:class="{
                  'history-details__active'    : indexDateRoute === routes.activeItem.date && indexDetails === routes.activeItem.details,
                  'history-details__highlight' : indexDateRoute === routes.highlightDate,
                  'history-details__parking'   : details.type === 1 }"
               v-for="(details, indexDetails) in dateRoute.list"
               v-bind:key="indexDetails"
               v-on:click="selectRoute(indexDateRoute, indexDetails)">
            <div class="history-details_cnt" v-if="details.type === 0">
              <div class="history-details_title">
                <div class="history-details_type">
                  Поездка
                </div>
                <!-- Больше года -->
                <div v-if="details.parkingPeriod.type === 0" class="durationEvent">
                  <span class="durationEvent_number">{{details.parkingPeriod.val1}}</span>
                </div>
                <!-- Дни часы, меньше года -->
                <div v-else-if="details.parkingPeriod.type === 1" class="durationEvent">
                  <span class="durationEvent_number">{{details.parkingPeriod.val1}}</span>дн
                  <span class="durationEvent_number">{{details.parkingPeriod.val2}}</span>ч
                </div>
                <!-- Часы минуты, меньше суток-->
                <div v-else-if="details.parkingPeriod.type === 2" class="durationEvent">
                  <span class="durationEvent_number">{{details.parkingPeriod.val1}}</span>ч
                  <span class="durationEvent_number" >{{details.parkingPeriod.val2}}</span>мин
                </div>
                <!-- Диапазон времени -->
                <div class="durationEvent_interval">
                  {{details.parkingPeriod.interval}}
                </div>
              </div>
              <div class="history-details_info">
                <div class="history-details_info-item" v-bind:style="{ backgroundImage: 'url(' + require('../../assets/img/historyroad/road2.svg') + ')' }">
                  <span class="history-details_info-val">{{ details.distance > 100 ? (details.distance).toFixed(1) : (details.distance).toFixed(2) }}</span> км
                </div>
                <div class="history-details_info-item" v-bind:style="{ backgroundImage: 'url(' + require('../../assets/img/historyroad/money.svg') + ')' }">
                  <span class="history-details_info-val" v-if="details.price">{{details.price}}</span>
									<span class="history-details_info-val" v-else>0</span> руб
                </div>
                <div class="history-details_info-item" v-bind:style="{ backgroundImage: 'url(' + require('../../assets/img/historyroad/feel.svg') + ')' }">
                  <span class="history-details_info-val">{{ calcFuel(details.fuel_consumption) }}</span> л
                </div>
                <div class="history-details_info-item" v-bind:style="{ backgroundImage: 'url(' + require('../../assets/img/historyroad/rek.svg') + ')' }">
                  <span class="history-details_info-val" v-if="details.distance === 0">0</span>
                  <span class="history-details_info-val" v-else>{{
										isNaN( (100 / details.distance * details.fuel_consumption ).toFixed(1) ) ? "0.0" : (100 / details.distance * details.fuel_consumption ).toFixed(1)
									}}</span>л / 100км
                </div>
                <div class="history-details_info-item" v-bind:style="{ backgroundImage: 'url(' + require('../../assets/img/historyroad/speed.svg') + ')' }">
                  <span class="history-details_info-val">{{details.speed_avg}}</span> км/ч
                </div>
                <div class="history-details_info-item" v-bind:style="{ backgroundImage: 'url(' + require('../../assets/img/historyroad/speedmax.svg') + ')' }">
                  <span class="history-details_info-val">{{details.speed_max}}</span> км/ч
                </div>
              </div>
            </div>
            <div class="history-details_cnt" v-else>
              <div class="history-details_title">
                <div class="history-details_type history-details_type__stop">
                  Стоянка
                </div>
                <!-- Больше года -->
                <div v-if="details.parkingPeriod.type === 0" class="durationEvent">
                  <span class="durationEvent_number">{{details.parkingPeriod.val1}}</span>
                </div>
                <!-- Дни часы, меньше года -->
                <div v-else-if="details.parkingPeriod.type === 1" class="durationEvent">
                  <span class="durationEvent_number">{{details.parkingPeriod.val1}}</span>дн
                  <span class="durationEvent_number">{{details.parkingPeriod.val2}}</span>ч
                </div>
                <!-- Часы минуты, меньше суток-->
                <div v-else-if="details.parkingPeriod.type === 2" class="durationEvent">
                  <span class="durationEvent_number">{{details.parkingPeriod.val1}}</span>ч
                  <span class="durationEvent_number">{{details.parkingPeriod.val2}}</span>мин
                </div>
                <!-- Диапазон времени -->
                <div class="durationEvent_interval">
                {{details.parkingPeriod.interval}}
              </div>
              </div>
              <div class="history-details_info">
                <div class="history-details_address">
                  <!--{{details.address}}-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </perfect-scrollbar>
    <perfect-scrollbar
        v-on:wheel="eventScroll"
        @ps-y-reach-end="eventReachEnd"
        v-if="events.listEvents.length && activeMenuItem === 1"
        ref="eventScroll">
      <div class="event-list">
        <div class="event-item"
             v-for="(dateEvent, indexDateEvent) in events.listEvents"
             v-bind:key="indexDateEvent">
          <div class="history-date">
            <div class="history-date_val">
              {{dateEvent.day}}
              {{listMonth[dateEvent.month]}}
            </div>
          </div>
          <div class="event-details"
               v-for="(detailsEvent, indexEventDetails) in dateEvent.list"
               v-bind:key="indexEventDetails"
               v-bind:class="{ 'event-details__active' : indexDateEvent === events.activeItem.date && indexEventDetails === events.activeItem.details }"
               v-on:click="selectEvent( indexDateEvent, indexEventDetails )">
            <div class="event-details_icon">
              <img v-if="detailsEvent.id !== 205
									 		&& detailsEvent.id !== 226
									 		&& detailsEvent.id !== 218
									 		&& detailsEvent.id !== 219
									 		&& detailsEvent.id !== 200
											&& detailsEvent.id !== 271
											&& detailsEvent.id !== 267
											&& detailsEvent.id !== 222
											&& detailsEvent.id !== 213
											&& detailsEvent.id !== 215
											&& detailsEvent.id !== 216
											&& detailsEvent.id !== 214"
									v-bind:src="require('../../assets/img/historyevent/'+ detailsEvent.id +'.svg')">
            </div>
            <div class="event-details_name">
              {{ eventName( detailsEvent.id ) }}
              <div v-if="detailsEvent.value" class="text-small">
                {{detailsEvent.value}}
              </div>
            </div>
            <div class="event-details_date">
              {{eventTime( detailsEvent.dt )}}
            </div>
          </div>
        </div>
      </div>
    </perfect-scrollbar>

    <div class="event-details"
         v-if="!routes.listRoutes.length && activeMenuItem === 0">
      Список пуст
    </div>
    <div class="event-details"
         v-if="!events.listEvents.length && activeMenuItem === 1">
      Список пуст
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../../main'
  import Datepicker from 'vuejs-datepicker';
  import {en, ru} from 'vuejs-datepicker/dist/locale'

  export default {
    data() {
      return {
        listMonth : ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
        activeMenuItem : -1,
        filterPanel : 0,
        paginatorLock : false,
        routes : {
          listRoutes : [],
          allRoutes : [],
          activeItem : {
            date : 0,
            details : 0
          },
          currentDate: '',
          highlightDate: -1,
          positionDates : [],
          past : '',
          future : '',
          positionTop : [],
          timePos : '',
          lock : false
        },
        events : {
          activeItem : {
            date : 0,
            details : 0
          },
          listEvents : [],
          allEvents : [],
          positionDates : [],
          currentDate : '',
          past : '',
          future : '',
          filter : '',
          positionTop : [],
          timePos : '',
          dictionary : ''
        },
        datepicker : {
          value: '',
          lang : {
            ru : ru,
            en : en
          },
          disabledDates: {
            from: new Date()
          },
          inputClass : 'datepickerField'
        },
      }
    },
    mounted(){
      // Словарь эвентов
      HTTP.get('events/').then( (response) => {
        this.events.dictionary = response.data;
        for( let i = 0; i < response.data.length; i++ ){
          if( response.data[i].is_event_filter === true ){
            this.events.dictionary.push({
              id   : response.data[i].id,
              name : response.data[i].name
            });
          }
        }
      }).catch( ( error ) => {
        this.$store.dispatch('errorResponse', error );
      });

      // Получаем маршруты
      this.getRoutes();
      this.getEvents();
    },
    computed : {
      currentCar : function(){
        return this.$store.state.cars.current
      },
      optionPanel : function () {
        return this.$store.state.panels
      },

      eventsFilter : function () {
        return this.$store.state.journal.filter.url
      },

      historyDay: function () {
        return this.$store.state.map.historyDay
      },

      timeZoneVal(){
        return this.$store.state.timezone
      }
    },
    methods : {
      // Открываем календарь
      openPicker : function () {
        this.$refs.datepicker.showCalendar();
      },
      // Лентой/По событиям
      changeMenuItem : function ( num ) {
        this.activeMenuItem = num;

        // Позиция скролла наверх
        if( document.getElementsByClassName('ps ps--active-y').length ){
          for( let i = 0; i < document.getElementsByClassName('ps ps--active-y').length; i++ ){
            document.getElementsByClassName('ps ps--active-y')[i].scrollTop = 0;
          }
        }

        // Передаём на карту текущий маршрут/событие/стоянку
        if( num === 0 ){
          this.$store.dispatch('journalRouteItem', this.routes.listRoutes[ this.routes.activeItem.date ].list[ this.routes.activeItem.details ] );
        }else{
          if( this.events.listEvents.length ){
            this.$store.dispatch('journalEventItem', this.events.listEvents[ this.events.activeItem.date ].list[ this.events.activeItem.details ] );
          }
        }
      },

      // Получаем Маршруты
      getRoutes : function ( dateQuery ) {
        let _this = this;
        let date;
        !dateQuery ? date = '' : date = dateQuery;

        HTTP.get('cars/' + this.currentCar.id + '/routes/' + date).then(function ( response ){
          _this.routes.allRoutes = response.data;

          // Форматируем
          _this.formatRoutes( response.data );

        }).catch(function( error ) {
          _this.$store.dispatch('errorResponse', error );
        })
      },
      // Форматируем маршруты
      formatRoutes : function ( response ) {
        let _this = this;
        this.paginatorLock = false;
        this.routes.listRoutes = [];

        // Форматируем
        for( let i in response.results ){
          // Разбивка полученных данных по дате
          let day = new Date( response.results[i].dt_start ).getDate(),
            month = new Date( response.results[i].dt_start ).getMonth();
          if( i > 0 ){
            if( day + "" + month !== _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].day + "" + _this.routes.listRoutes[ _this.routes.listRoutes.length -1 ].month ){
              _this.routes.listRoutes.push({
                day: day,
                month: month,
                list : []
              });
              _this.routes.listRoutes[ _this.routes.listRoutes.length - 1].list.push( _this.routes.allRoutes.results[ i ] );
            }else{
              _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list.push( _this.routes.allRoutes.results[ i ] );
            }
          }else{
            _this.routes.listRoutes.push({
              day: day,
              month: month,
              list : []
            });
            _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list.push( _this.routes.allRoutes.results[ i ] );
          }
          // Длительность стоянки/поездки
          let dt_startUTC = new Date( response.results[i].dt_start );
          dt_startUTC.setHours( dt_startUTC.getHours() - this.timeZoneVal/60 );
          let dt_stopUTC = new Date( response.results[i].dt_stop );
          dt_stopUTC.setHours( dt_stopUTC.getHours() - this.timeZoneVal/60 );

          let milliseconds = new Date( response.results[i].dt_stop ) - new Date( response.results[i].dt_start ),
            seconds = milliseconds / 1000,
            minutes = seconds / 60,
            hours = minutes / 60,
            days = hours / 24,
            interval = ( dt_startUTC.getHours()<10?'0':'') + dt_startUTC.getHours() + ':' +
              (dt_startUTC.getMinutes()<10?'0':'') + dt_startUTC.getMinutes() + ' - ' +
              (dt_stopUTC.getHours()<10?'0':'') + dt_stopUTC.getHours() + ':' +
              (dt_stopUTC.getMinutes()<10?'0':'') + dt_stopUTC.getMinutes();

          if( hours > 23.99 ){
            if( days > 365 ){
              _this.$set( _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list[ _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list.length - 1 ], 'parkingPeriod', {
                'type' : 0,
                'val1' : 'Больше года',
                'interval': interval
              });
            }else{
              _this.$set( _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list[ _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list.length - 1 ], 'parkingPeriod', {
                'type' : 1,
                'val1' : Math.floor(hours / 24), // дн
                'val2' : Math.floor(hours - Math.floor(hours / 24)*24 ), // ч
                'interval' : interval
              });
            }
          }else{
            _this.$set( _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list[ _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list.length - 1 ], 'parkingPeriod', {
              'type' : 2,
              'val1' : Math.floor(minutes / 60), // ч
              'val2' : Math.floor(minutes - Math.floor(minutes / 60)*60 ), // мин
              'interval' : interval
            });
          }

          // Декодирование точек
          let polyline = {};
          polyline.decode = function(str, precision) {
            var index = 0,
              lat = 0,
              lng = 0,
              coordinates = [],
              shift = 0,
              result = 0,
              byte = null,
              latitude_change,
              longitude_change,
              factor = Math.pow(10, precision || 6);

            while (index < str.length) {

              // Reset shift, result, and byte
              byte = null;
              shift = 0;
              result = 0;

              do {
                byte = str.charCodeAt(index++) - 63;
                result |= (byte & 0x1f) << shift;
                shift += 5;
              } while (byte >= 0x20);

              latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

              shift = result = 0;

              do {
                byte = str.charCodeAt(index++) - 63;
                result |= (byte & 0x1f) << shift;
                shift += 5;
              } while (byte >= 0x20);

              longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

              lat += latitude_change;
              lng += longitude_change;

              coordinates.push({ 'lat' : lat / factor, 'lng' : lng / factor });
            }

            return coordinates;
          };
          let polyline2 = polyline.decode(response.results[i].points);
          _this.$set( _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list[ _this.routes.listRoutes[ _this.routes.listRoutes.length - 1 ].list.length - 1 ], 'listPoints', polyline2);


          // Позиции дат
          setTimeout(function () {
            _this.routes.positionDates = [];
            let listDates = document.getElementsByClassName('history-date');
            for( let i = 0; i < listDates.length; i++ ){
              _this.routes.positionDates.push( listDates[i].offsetTop );
            }
          }, 500);

          // Будущее/прошлое
          if( response.past_args !== null ){
            _this.routes.past = response.past_args.cursor[0];
          }else{
            _this.routes.past = null;
          }
          if( response.future_args !== null ){
            _this.routes.future = response.future_args.cursor[0];
          }else{
            _this.routes.future = null;
          }
        }

        if( this.activeMenuItem === -1 ){
          this.changeMenuItem(0)
        }

        // текущая дата
        if( !this.routes.currentDate ){
          this.routes.currentDate = this.routes.listRoutes[0].day + ' ' + this.listMonth[ _this.routes.listRoutes[0].month ];
        }else{
          if( this.routes.allRoutes.results.length < 11 ){
            this.$refs.routeScroll.$el.scrollTop = document.getElementsByClassName('history-details__active')[0].offsetTop -50;
            this.routes.currentDate = this.routes.listRoutes[0].day + ' ' + this.listMonth[ _this.routes.listRoutes[0].month ];
          }
        }
      },
      // Выбрали маршрут/стоянку
      selectRoute : function (indexDateRoute, indexDetails) {
        this.routes.activeItem.date = indexDateRoute;
        this.routes.activeItem.details = indexDetails;
        this.routes.highlightDate = -1;

        this.$store.dispatch('journalRouteItem', this.routes.listRoutes[indexDateRoute].list[indexDetails]);
      },
      // Скролл Маршрутов, Пэгинация вверх
      routeScroll : function ( evt ) {
        let pos = evt.currentTarget.scrollTop+evt.deltaY;

        // Подставляем дату по уровню
        for( let i = 0; i < this.routes.positionDates.length; i++ ){
          if( pos >= this.routes.positionDates[i] ){
            this.routes.currentDate = this.routes.listRoutes[i].day + ' ' + this.listMonth[ this.routes.listRoutes[i].month ];
          }
        }

        // Пэгинация вверх
        if( pos < 1 ){
          let _this = this;
          if(_this.routes.future !== null ){
            this.paginatorLock = true;


            HTTP.get('cars/' + this.currentCar.id + '/routes/?cursor=' +_this.routes.future ).then(function (response) {
              // добавляем точки
              for( let i = response.data.results.length-1; i > -1; i-- ){
                _this.routes.allRoutes.results.unshift( response.data.results[i] );
              }

              // форматируем
              _this.formatRoutes( _this.routes.allRoutes );

              // прошлое
              if( response.data.future_args !== null ){
                _this.routes.future = response.data.future_args.cursor[0];
              }else{
                _this.routes.future = null;
              }
            }).catch(function ( error ) {
              _this.$store.dispatch('errorResponse', error );
            });
          }
        }
      },
      // Пэгинация вниз
      routeReachEnd : function () {
        let _this = this;

        if( this.routes.past !== null ){
          let past = this.routes.past;
          this.routes.past = null;
          this.paginatorLock = true;
          HTTP.get('cars/' + this.currentCar.id + '/routes/?cursor=' + past ).then(function (response) {
            // добавляем точки
            for( let i = 0; i < response.data.results.length; i++ ){
              _this.routes.allRoutes.results.push( response.data.results[i] );
            }

            // форматируем
            _this.formatRoutes( _this.routes.allRoutes );

            // прошлое
            if( response.data.past_args !== null ){
              _this.routes.past = response.data.past_args.cursor[0];
            }else{
              _this.routes.past = null;
            }
          }).catch(function ( error ) {
            _this.$store.dispatch('errorResponse', error );
          });
        }
      },

      // Получаем список событий
      getEvents : function ( dateQuery ) {
        let date;
        if( !dateQuery ){
          date = '';
          if( this.eventsFilter !== '' && this.eventsFilter !== 'empty' || this.eventsFilter !== 'full' ){
            date += '?' + this.eventsFilter.substr(1);
          }
        }else{
          date = dateQuery;
          if( this.eventsFilter !== '' && this.eventsFilter !== 'empty' || this.eventsFilter !== 'full' ){
            date += this.eventsFilter;
          }
        }

        HTTP.get('cars/' + this.currentCar.id + '/events/' + date)
					.then( (response) => {
						//
						this.events.allEvents = response.data;

						// форматируем
						this.formatEvents( this.events.allEvents );

					}).catch( ( error ) => {
						this.$store.dispatch('errorResponse', error );
					});
      },
      // Форматируем события
      formatEvents : function( response ) {
        let _this = this;
        this.paginatorLock = false;
        this.events.listEvents = [];

        if( response.results.length ){
          for( let i in response.results ){
            let day = new Date( response.results[i].dt ).getDate(),
              month = new Date( response.results[i].dt ).getMonth();
            if( i > 0 ){
              if( day + "" + month !== _this.events.listEvents[ _this.events.listEvents.length - 1 ].day + "" + _this.events.listEvents[ _this.events.listEvents.length -1 ].month ){
                _this.events.listEvents.push({
                  day: day,
                  month: month,
                  list : []
                });
                _this.events.listEvents[ _this.events.listEvents.length - 1].list.push( _this.events.allEvents.results[ i ] );
              }else{
                _this.events.listEvents[ _this.events.listEvents.length - 1 ].list.push( _this.events.allEvents.results[ i ] );
              }
            }else{
              _this.events.listEvents.push({
                day: day,
                month: month,
                list : []
              });
              _this.events.listEvents[ _this.events.listEvents.length - 1 ].list.push( _this.events.allEvents.results[ i ] );
            }
          }

          setTimeout(function () {
            // Позиции дат
            _this.events.positionDates = [];
            let listDates = document.getElementsByClassName('history-date');
            for( let i = 0; i < listDates.length; i++ ){
              _this.events.positionDates.push( listDates[i].offsetTop );
            }
          }, 200);

          // текущая дата
          _this.events.currentDate = _this.events.listEvents[0].day + ' ' + _this.listMonth[ _this.events.listEvents[0].month ];
        }

        // Будущее/прошлое
        if( response.past_args !== null ){
          _this.events.past = response.past_args.cursor[0];
        }else{
          _this.events.past = null;
        }
        if( response.future_args !== null ){
          _this.events.future = response.future_args.cursor[0];
        }else{
          _this.events.future = null;
        }

      },
      // Выбрали событие
      selectEvent : function (indexDateEvent, indexEventDetails) {
        this.events.activeItem.date = indexDateEvent;
        this.events.activeItem.details = indexEventDetails;

        this.$store.dispatch('journalEventItem', this.events.listEvents[ indexDateEvent ].list[ indexEventDetails ] );
      },
      // Долистали до верха
      eventScroll : function( evt ){
        let pos = evt.currentTarget.scrollTop+evt.deltaY;

        // Подставляем дату по уровню
        for( let i = 0; i < this.events.positionDates.length; i++ ){
          if( pos >= this.events.positionDates[i] ){
            this.events.currentDate = this.events.listEvents[i].day + ' ' + this.listMonth[ this.events.listEvents[i].month ];
          }
        }

        // Пэгинация вверх
        if( pos < 1 ){

          if( this.events.future !== null ){
            this.paginatorLock = true;
            HTTP.get('cars/' + this.currentCar.id + '/events/?cursor=' + this.events.future + this.events.filter).then( response => {
              // добавляем точки
              for( let i = response.data.results.length-1; i > -1; i-- ){
                this.events.allEvents.results.unshift( response.data.results[i] );
              }

              // форматируем
              this.formatEvents( this.events.allEvents );

              // прошлое
              if( response.data.future_args !== null ){
                this.events.future = response.data.future_args.cursor[0];
              }else{
                this.events.future = null;
              }
            }).catch( error => {
              this.$store.dispatch('errorResponse', error );
            });
          }
        }
      },
      // Долистали до низа
      eventReachEnd : function () {
        let _this = this;

        if( this.events.past !== null ){
          let past = this.events.past;
          this.events.past = null;
          this.paginatorLock = true;

          HTTP.get('cars/' + this.currentCar.id + '/events/?cursor=' + past + this.events.filter ).then(function (response) {
            // добавляем точки
            for( let i = 0; i < response.data.results.length; i++ ){
              _this.events.allEvents.results.push( response.data.results[i] );
            }

            // форматируем
            _this.formatEvents( _this.events.allEvents );

            // прошлое
            if( response.data.past_args !== null ){
              _this.events.past = response.data.past_args.cursor[0];
            }else{
              _this.events.past = null;
            }
          }).catch(function ( error ) {
            _this.$store.dispatch('errorResponse', error );
          });
        }
      },

      // Открываем фильтры событий
      openFilterPanel : function () {
        if( this.optionPanel.option.status === 0 ){
          this.$store.dispatch('optionPanel', 1);
          this.$store.dispatch('optionPanelType', 3);
          this.changeMenuItem(1);
        }else{
          this.$store.dispatch('optionPanel', 0);
          this.$store.dispatch('optionPanelType', 0);
        }
      },

      // Выбор всех поездок за день
      selectHistoryDay : function ( date ) {
        let listIndex = -1,
            day,
            month;

        if( !date ){
          day   = parseInt( this.routes.currentDate.replace(/\D/gi, '') );
          month = parseInt( this.listMonth.indexOf( this.routes.currentDate.replace(/\w+\s/, '') ) );
        }else{
          day   = date.day;
          month = date.month;
        }

        for( let i = 0; i < this.routes.listRoutes.length; i++ ){
          if( this.routes.listRoutes[i].day === day && this.routes.listRoutes[i].month === month ){
            listIndex = i;
            break;
          }
        }

        if( this.routes.highlightDate !== listIndex ){
          this.routes.highlightDate = listIndex;
          this.routes.activeItem.date = -1;
          this.routes.activeItem.details = -1;

          this.$store.dispatch('changeHistoryDay', this.routes.listRoutes[listIndex].list );
        }else{
          this.routes.highlightDate = -1;
          this.routes.activeItem.date = 0;
          this.routes.activeItem.details = 0;

          this.$store.dispatch('changeHistoryDay', 'empty' );
        }
      },


      /* --- [ Вычисляемые данные ] --- */
      // Название Эвента
      eventName : function( id ) {
        for( let i = 0; i < this.events.dictionary.length; i++ ){
          if( this.events.dictionary[i].id === id ){
            return this.events.dictionary[i].name;
          }
        }
      },
      // Время событий
      eventTime : function ( cD ) {
        let date = new Date( cD );
        date.setHours( date.getHours() - this.timeZoneVal/60 );

        let hours = new Date( date ).getHours().toString().length === 1 ? '0' + new Date( date ).getHours() : new Date( date ).getHours(),
          minutes =  new Date( date ).getMinutes().toString().length === 1 ? '0' + new Date( date ).getMinutes() : new Date( date ).getMinutes();
        return hours + ':' + minutes;
      },
      // Подсчет топлива
      calcFuel : function ( val ) {
        if( val ){
          let inxDot = val.toString().indexOf('.');

          switch (inxDot){
            case 2:
              val = val.toFixed(1);
              break;
            case 1:
              val = val.toFixed(2);
              break;
            default:
              val = val.toFixed(0)
          }

          return val;
        }else{
          return 0;
        }



      }
    },
    watch : {
      'datepicker.value' : function(newVal) { // 7 июля мерседес
        //let _this = this;
        let mnt = newVal.getMonth() + 1;
        let selectedDate = '?dt=' + newVal.getFullYear() + '-' + mnt + '-' + newVal.getDate() + 'T00%3A00%3A00';

        //this.activeMenuItem = -1;
        this.routes.activeItem.date = 0;
        this.routes.activeItem.details = 0;
        this.events.activeItem.date = 0;
        this.events.activeItem.details = 0;

        // получаем историю поездок
        this.getRoutes( selectedDate );

        // Получаем события
        this.getEvents( selectedDate )
      },
      eventsFilter : function ( data ) {
        let _this = this;
        this.paginatorLock = true;

        if( data === 'empty' || data === 'full' ){
          this.events.filter = '';
        }else{
          this.events.filter = "?" + data.substr(1);
        }

        // Получаем события
        HTTP.get('cars/' + this.currentCar.id + '/events/' + this.events.filter ).then(function (response) {
          _this.events.allEvents = response.data;

          // форматируем
          _this.formatEvents( _this.events.allEvents );

          // текущая дата
          //_this.events.currentDate = _this.events.listEvents[0].day + ' ' + _this.listMonth[ _this.events.listEvents[0].month ];

          // Будущее/прошлое
          if( response.data.past_args !== null ){
            _this.events.past = response.data.past_args.cursor[0];
          }else{
            _this.events.past = null;
          }
          if( response.data.future_args !== null ){
            _this.events.future = response.data.future_args.cursor[0];
          }else{
            _this.events.future = null;
          }


          if( document.getElementsByClassName('ps ps--active-y').length ){
            for( let i = 0; i < document.getElementsByClassName('ps ps--active-y').length; i++ ){
              document.getElementsByClassName('ps ps--active-y')[i].scrollTop = 0;
            }
          }
        }).catch(function ( error ) {
          _this.$store.dispatch('errorResponse', error );
        });
      }
    },
    components : {
      Datepicker
    }
  }
</script>